import React from "react";
import { connect } from "react-redux";
import {
    Navigate,
    Outlet,
    useLoaderData,
    useLocation,
} from "react-router-dom";
import { bindActionCreators } from "redux";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header.jsx";

const MainLayout = (props) => {
    const tenantData = useLoaderData();
    const location = useLocation();
    const isResetPage = location.pathname.includes("/reset");
    const isDeliveryPickup = props.delivery_pickup.length === 0;
    if (!tenantData) {
        return <Navigate to="/404" replace />;
    } else if (isDeliveryPickup && !location.pathname.includes("/category")) {
        return <Navigate to={`/${localStorage.getItem("tenant")}`} replace />;
    }

    return (
        <>
            {!isResetPage && <Header />}
            <main>
                <Outlet />
            </main>
            {!isResetPage && <Footer />}
        </>
    );
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}

function mapStateToProps(state) {
    return {
        delivery_pickup: state.delivery_pickup,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
